import axios from 'axios';

export async function saveInquiry(stage, payload) {
  const apiUrl = process.env.REACT_APP_INQUIRY_API_URL || process.env.REACT_APP_INQUIRY_DEV_API_URL;
  if (!apiUrl) {
    throw new Error('문의 API 주소를 설정하세요.');
  }
  // 동일 제출의 통신 재시도는 같은 키를 사용하고 성공 후에는 지운다.
  const storageKey = `inquiry-request:${stage}:${JSON.stringify(payload)}`;
  const requestKey = sessionStorage.getItem(storageKey) || crypto.randomUUID();
  sessionStorage.setItem(storageKey, requestKey);
  const requestBody = {
    stage, requestKey, payload,
    name: payload.UserName || payload.BookerName,
    phone: payload.UserPhone || payload.BookerPhoneNumber,
    email: payload.UserEmail || payload.BookerEmailAddress,
    inflowId: payload.Inflow || payload.Route || 'website',
  };
  const { data } = await axios.post(apiUrl, requestBody);
  sessionStorage.removeItem(storageKey);
  return data.result;
}
